import React, { useState } from "react";
import CustomLoader from "./loader";

const styles = {
  container: (width, height, borderRadius, customStyle) => ({
    position: "relative",
    display: "inline-block",
    width: width,
    height: height,
    borderRadius: borderRadius,
    overflow: "hidden",
    ...customStyle,
  }),
  loaderWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  image: (loaded, borderRadius) => ({
    display: loaded ? "block" : "none",
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: borderRadius,
  }),
};

export default function ImageWithLoader({
  src,
  alt,
  className,
  style,
  width,
  height,
  borderRadius = 4,
  fallbackSrc = "/assets/images/placeholder.png", // 🔥 default placeholder
}) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const handleError = () => {
    setError(true);
    setLoaded(true);
  };

  return (
    <div
      style={styles.container(width, height, borderRadius, style)}
      className={className}
    >
      {!loaded && (
        <div style={styles.loaderWrapper}>
          <CustomLoader color="#d3d3d3" />
        </div>
      )}

      <img
        src={error ? fallbackSrc : src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        onError={handleError}
        style={styles.image(loaded, borderRadius)}
      />
    </div>
  );
}
